module.exports = __webpack_public_path__ + "img/product12p.d91c8811.png";